<template>
  <VFooter
    app
    color="secondary"
    style="height: initial; min-height: 420px; position: static;"
  >
    <div
      class="px-4 responsive-margin"
      style="width: 100%;"
    >
      <div
        class="pacifico text-xs-center primary--text mt-5 pb-4"
        style="font-size: 22px; border-bottom: 3px solid white;"
      >
        Csomagolástechnika Békéscsaba 2500m<sup>2</sup>-én
      </div>

      <div style="border-bottom: 3px solid white;">
        <VLayout
          wrap
          justify-space-around
          class="white--text mt-5 maximize"
        >
          <VFlex
            class="mb-4"
            xs12
            sm4
            style="max-width: 300px;"
          >
            <RouterLink :to="{ name: 'About' }">
              <div class="title font-weight-bold">
                Körös Print-Packról
              </div>
            </RouterLink>

            <div class="text-xs-justify mt-3">
              Professzionális nyomdai szolgáltatások 30 éve.
              Igényes kivitelű faltkarton dobozok, reklámanyagok és íves címkék gyártása.<br>
              Szoros kapcsolatot ápolva vevőinkkel,
              akik nagyra értékelik az ügyfélközpontú kiszolgálást,
              a minőségi termékeket valamint a határidők pontos betartását.
            </div>
          </VFlex>

          <VFlex
            class="mb-4 px-4"
            xs12
            sm4
            style="max-width: 300px;"
          >
            <RouterLink :to="{ name: 'Services' }">
              <div class="title font-weight-bold">
                Szolgáltatások
              </div>
            </RouterLink>

            <div class="mt-3">
              <ul>
                <RouterLink
                  v-for="service in services"
                  :key="service.title"
                  :to="{ name: 'Services', params: { slug: service.slug } }"
                >
                  <li>
                    {{ service.title }}
                  </li>
                </RouterLink>

                <RouterLink
                  v-for="subService in services[0].subServices.filter(({ inFooter }) => inFooter)"
                  :key="subService.title"
                  :to="{
                    name: 'SubServices',
                    params: { serviceSlug: 'dobozgyartas', subServiceSlug: subService.slug }
                  }"
                >
                  <li>
                    {{ subService.title }}
                  </li>
                </RouterLink>
              </ul>
            </div>
          </VFlex>

          <VFlex
            class="mb-4 px-4"
            xs12
            sm4
            style="max-width: 300px;"
          >
            <RouterLink :to="{ name: 'Contact' }">
              <div class="title font-weight-bold">
                Kapcsolat
              </div>
            </RouterLink>

            <a href="mailto:info@print-pack.hu">
              <div class="mt-3">
                info@print-pack.hu
              </div>
            </a>

            <a
              href="https://www.google.com/maps/dir//46.6621705,21.0760266/@46.66217,21.076027,18z?hl=en-US"
              target="_blank"
            >
              <div
                class="mt-3"
                style="max-width: 150px;"
              >
                5600 Békéscsaba, Orosházi út 32.
              </div>
            </a>
          </VFlex>
        </VLayout>
      </div>

      <div class="white--text maximize">
        <VLayout wrap>
          <VFlex xs12>
            <div class="mt-4 text-sm-center text-md-left">
              Made with ❤ by
              <a
                href="https://impressia.hu/"
                target="_blank"
              >
                Impressia
              </a>
              <br>
              © 1989-{{ new Date().getFullYear() }} Körös Print-Pack Kft.
            </div>

            <div class="text-sm-center text-md-left">
              <RouterLink :to="{ name: 'PrivacyStatement' }">
                Adatvédelmi nyilatkozat
              </RouterLink>
              |
              <RouterLink :to="{ name: 'LegalNotice' }">
                Jogi nyilatkozat
              </RouterLink>
              |
              <RouterLink :to="{ name: 'PrivacyPolicy' }">
                Adatkezelési tájékoztató
              </RouterLink>
            </div>
          </VFlex>

          <VFlex xs12>
            <VLayout
              class="my-3 fullWidth contactRow"
            >
              <ContactRow
                :colors="['#42a5f5', '#ff80ab', '#ffea00', '#ffffff']"
              />
            </VLayout>
          </VFlex>
        </VLayout>
      </div>
    </div>
  </VFooter>
</template>

<script>
import ContactRow from '@/components/ContactRow.vue';
import servicesData from '@/data/services.json';

export default {
  name: 'TheSiteFooter',
  components: {
    ContactRow,
  },
  data: () => ({
    services: servicesData,
  }),
};
</script>

<style scoped>
a {
  text-decoration: none;
  color: white;
}

@media (max-width: 959px) {
  .contactRow {
    justify-content: center !important;
  }
}

.responsive-margin {
  margin-bottom: 10px;
}

@media (max-width: 900px) {
  .responsive-margin {
    margin-bottom: 150px;
  }
}
</style>
